/* global global */

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as gcnav_datalayer from '../../gift_catalogue/datalayer/gcnav.js';
import * as gccat_datalayer from '../../gift_catalogue/datalayer/gccat.js';
import * as gc_featured_datalayer from '../../gift_catalogue/datalayer/gc_featuredproduct.js';
import * as gc_tabbed_datalayer from '../../gift_catalogue/datalayer/gc_tabbedproduct.js';
import * as gtm_vars from '../../datalayer/gtm/gtm_vars.js';
import * as gtm_push from '../../datalayer/gtm/gtm_push.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as sort_collection from '../../util/sort_collection.js';
import * as tealium from '../../datalayer/tealium.js';
import * as tabbed_card_handler from '../../gift_catalogue/card/tabbed_card_handler.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'gcall';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------
function init_pagevars() {
    PAGE_VARS.kind = PageKind.GiftCatalogue;
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    all_modules.push(
        sort_collection,
        gtm_vars,
        gcnav_datalayer,
        gccat_datalayer,
        gc_featured_datalayer,
        gc_tabbed_datalayer,
        gtm_push,
        tabbed_card_handler
    );

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
